<template>
    <div class="container roles-index-container">
        <template v-show="!isLoading">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="card-header-label col-2">
                            <span class="mdi mdi-account-star custom-icon"></span>
                            <span>Roles</span>
                        </div>
                        <div class="card-header-search-bar col-5">
                            <input type="text" v-model="filter" id="filter-input" placeholder="Escriba aquí el texto a buscar" class="form-control">
                        </div>
                        <div class="card-header-pagination col-3">
                            <b-pagination 
                                v-model="currentPage" 
                                :total-rows="filteredRoles.length"
                                :per-page="perPage" 
                                aria-controls="roles-table" 
                                style="margin: 0;"
                                align="center"
                            />
                        </div>
                        <div class="card-header-action-buttons col-2">
                            <div>
                                <ButtonComponent
                                :buttonText="'Nuevo'"
                                :buttonColor="colors.GREEN_COLOR_BUTTON"
                                :buttonAction="openCreateRoleModal"
                                />
                                <ButtonComponent
                                :buttonText="'Resfrescar'"
                                :buttonColor="colors.BLUE_COLOR_BUTTON"
                                :buttonAction="refreshData"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isLoading" style="padding: 5ch 0;">
                    <SpeenComponent 
                        :isAutomatic="true" 
                        :ringWidth="14" 
                        :spinnerSize="15" 
                        :isverticalAligned="true" 
                    />
                </div>
                <div class="card-body" v-else>
                    <b-table 
                        :items="filteredRoles" 
                        :fields="fields" 
                        small striped hover 
                        :per-page="perPage" 
                        :current-page="currentPage" 
                        id="roles-table">
                        <template #cell(actions)="data">
                            <ButtonComponent
                                :buttonText="'Usuarios / Paquetes'"
                                :buttonColor="colors.GREEN_COLOR_BUTTON"
                                :buttonAction="() => openRoleDetailsModal(data.item)"
                            />
                            <ButtonComponent
                                v-if="!isRoleForbidden(data.item)"
                                :buttonText="'Borrar'"
                                :buttonColor="colors.RED_COLOR_BUTTON"
                                :buttonAction="() => confirmDeleteUser(data.item)"
                            />
                        </template>
                    </b-table>
                </div>
            </div>

            <transition name="slide-fade">
                <WarningModal
                    v-if="showWarningModal"
                    :closeWarning="closeWarning"
                    :warningMessage="warningMessage"
                />
                <ActionConfirmModal
                    v-if="showActionConfirmModal"    
                    :methodForProp="methodeForProp"
                    :closeModal="closeActionConfirmModal"
                    :contentMessage="actionConfirmModalMessage"
                />
                <RoleCreateModal
                    v-if="showRoleCreateModal"
                    @role-created="refreshData"
                    @close-modal="closeCreateRoleModal"
                />
                <PermissionManageModal
                    v-if="showPermissionManageModal"
                    :roleId="selectedRoleId"
                    :roleName="selectedRoleName"
                    :usersData="usersData"
                    :totalPermissionPackages="totalPermissionPackages"
                    :isForbiddenRole="isForbiddenRole"
                    @close-modal="closeRoleDetailsModal"
                />
            </transition>
        </template>
    </div>
</template>

<script>
import axios from 'axios';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import ButtonComponent from '../../common/components/ButtonComponent.vue';
import Colors from '../../common/colors';
import ActionConfirmModal from '../../common/components/modals/ActionConfirmModal.vue';
import WarningModal from '../../common/components/modals/WarningModal.vue';
import RoleCreateModal from '../components/RoleCreateModal.vue';
import PermissionManageModal from '../components/PermissionManageModal.vue';

export default {
    name: 'RolesIndex',
    components: {
        SpeenComponent,
        ButtonComponent,
        ActionConfirmModal,
        WarningModal,
        RoleCreateModal,
        PermissionManageModal
    },
    data() {
        return {
            rolesData: [],
            usersData: [],
            totalPermissionPackages: [],
            isLoading: true,
            filter: '',
            currentPage: 1,
            perPage: 10,
            colors: Colors,
            showWarningModal: false,
            showActionConfirmModal: false,
            warningMessage: '',
            actionConfirmModalMessage: '',
            methodeForProp: null,
            showRoleCreateModal: false,
            showPermissionManageModal: false,
            selectedRoleName: '',
            selectedRoleId: '',
            fields: [
                { key: 'name', label: 'Rol', sortable: true, thStyle: { width: '80%' }, tdStyle: { width: '80%' }, },
                { key: 'actions', label: 'Acciones', sortable: false, thStyle: { width: '20%' }, tdStyle: { width: '20%' }, }
            ],
        };
    },
    mounted() {
        this.getRolesPermissionsVueData();
    },
    methods: {
        refreshData(){
            this.getRolesPermissionsVueData();
        },
        getRolesPermissionsVueData() {
            this.isLoading = true;
            axios.get('/api/vue-data/settings-permissions')
                .then(response => {
                    this.rolesData = response.data.rolesWithPermissionPackages;
                    this.usersData = response.data.users;
                    this.totalPermissionPackages = response.data.permissionPackages;
                })
                .catch(error => {
                    console.error('Error al obtener datos:', error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        confirmDeleteUser(role) {
            this.actionConfirmModalMessage = `¿Estás seguro de eliminar el rol "${role.name}"?`;
            this.methodeForProp = () => {
                this.deleteRole(role.id);
            };
            this.openActionConfirmModal();
        },
        deleteRole(roleId) {
            axios.delete(`/api/roles/${roleId}/delete`)
                .then(response => {
                    this.getRolesPermissionsVueData();
                    showCustomSuccessSweetAlert('Rol eliminado correctamente');
                })
                .catch(error => {
                    console.error('Error al eliminar role:', error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.closeActionConfirmModal();
                });
        },
        isRoleForbidden(role) {
            const forbiddenRoleNames = ['admin', 'operator', 'superadmin', 'user'];
            return forbiddenRoleNames.includes(role.name);
        },
        openCreateRoleModal() {
            this.showRoleCreateModal = true;
        },
        closeCreateRoleModal() {
            this.showRoleCreateModal = false;
        },
        openRoleDetailsModal(role) {            
            this.selectedRoleName = role.name;
            this.selectedRoleId = role.id;
            this.showPermissionManageModal = true;
        },
        closeRoleDetailsModal() {
            this.showPermissionManageModal = false;
        },
        closeWarning() {
            this.showWarningModal = false;
        },
        openActionConfirmModal() {
            this.showActionConfirmModal = true;
        },
        closeActionConfirmModal() {
            this.showActionConfirmModal = false;
        },
    },
    computed: {
        isForbiddenRole() {
            let roleName = this.rolesData.find(role => role.id == this.selectedRoleId)?.name;
            let forbiddenRoleNames = ['admin', 'operator', 'superadmin', 'user'];
            let isForbiddenRole = forbiddenRoleNames.includes(roleName);
            return isForbiddenRole;
        },
        filteredRoles() {
            return this.rolesData.filter(role => role.name.toLowerCase() !== 'superadmin' &&
                (!this.filter || role.name.toLowerCase().includes(this.filter.toLowerCase())));
        }
    },
};
</script>

<style lang="scss">

</style>
